import React from 'react';

const SubmitInquiries = () => {
  const isUserRegistered = false; // Replace with actual authentication logic if needed.

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-gray-800">
      {!isUserRegistered && (
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold mb-4">Access Restricted</h1>
          <p className="text-lg mb-4">
            Only registered users can submit inquiries. For early access, please contact{' '}
            <a href="mailto:info@ambivert.ai" className="text-blue-500 underline">
              info@ambivert.ai
            </a>
          </p>
        </div>
      )}

      <div className="p-6 bg-gray-50 text-gray-800 max-w-4xl">
        <h1 className="text-4xl font-bold mb-6 text-center">Submit Your Inquiry</h1>
        <p className="text-lg mb-4">
          At Ambivert.ai, we understand that every organization has unique challenges. By submitting your inquiries,
          you allow us to craft tailored AI solutions that align with your business goals.
        </p>
        <p className="text-lg mb-4">
          Our platform uses advanced AI to analyze your challenges and propose actionable insights, tools, and use cases
          to drive your success.
        </p>
        <p className="text-lg">
          Whether you're exploring AI adoption for the first time or seeking optimization in existing processes, 
          let us help you navigate your AI journey effectively.
        </p>
      </div>
    </div>
  );
};

export default SubmitInquiries;